export const parseFileString = (fileString: string) => {
  const lastSlashIdx = fileString.lastIndexOf('/');
  const fileNameAfterSlash = fileString.slice(lastSlashIdx + 1);
  const questionMarkIdx = fileNameAfterSlash.indexOf('?') || undefined;
  return fileNameAfterSlash.slice(0, questionMarkIdx);
};
